export default __webpack_public_path__ + "static/media/img1.92867960.webp";